import {
  CREATE_SPARE_PART_ATTRIBUTE_SUCCESS,
  FETCH_SPARE_PART_ATTRIBUTE_SUCCESS,
  GET_SPARE_PART_ATTRIBUTE_SUCCESS,
  SAVE_SPARE_PART_ATTRIBUTE_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_SPARE_PART_ATTRIBUTE_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_SPARE_PART_ATTRIBUTE_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.count,
      }
    }

    case CREATE_SPARE_PART_ATTRIBUTE_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_SPARE_PART_ATTRIBUTE_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }


    default:
      return state;
  }
}
